import { CompanyShowType as ApiCompanyShowType } from 'src/api/generated/touring/types';
import { mapShowWithTourType } from '../common';
import { CompanyShowType } from './types';

export const mapCompanyShow = (apiCompanyShow: ApiCompanyShowType): CompanyShowType => {
  const showWithTour = mapShowWithTourType(apiCompanyShow.showWithTour);

  return {
    showWithTour,
    showDate: showWithTour.showDate,
    dealType: apiCompanyShow.dealType ?? null,
    production: apiCompanyShow.production ?? null,
    showSetup: apiCompanyShow.showSetup ?? null,
    configuration: apiCompanyShow.configuration ?? null,
    status: apiCompanyShow.status,
  };
};
